<template>
  <div class="-header -hull">
    <div class="-hull-head" />
    <sort-label class="-cell -hull-c1" value="title" label="Track" />
    <sort-label class="-cell -hull-c2" value="creationDate" label="Creation" />
    <sort-label class="-cell -hull-c3" value="genre" label="Genre" />
    <sort-label class="-cell -hull-c4" value="mood" label="Mood" />
    <sort-label class="-cell -hull-c5" value="pace" label="Pace" />
    <div class="-hull-tail" />
  </div>
</template>

<script>
import app from 'app';

const SortLabel = app.Vue.extend({
  template: `
<div @click="onChangeSortOrder">
    <div class="-label">{{label}}<i :class="isOrdered"/></div>
</div>
`.normalizeSpace(),

  props: {
    value: { type: String, required: true },
    label: { type: String, required: true },
  },

  computed: {
    isOrdered() {
      let order = '';
      if (this.value === this.$store.state.filter.sortBy) {
        order = this.$store.state.filter.asc ? 'asc' : 'desc';
      }
      return order;
    },
  },

  methods: {
    onChangeSortOrder() {
      this.$store.dispatch('SET_SORT_ORDER', this.value);
    },
  },
});
export default {
  components: {
    SortLabel,
  },
};
</script>
